

































































































































































































































































































import { Datetime } from 'vue-datetime'
import Input from '@/types/Input.interface'
import Media from '@/types/Media.interface'
import Vue from 'vue'
import moment from 'moment-timezone'
import { objectGet, objectSet, unmask } from '@/utility/helpers'
export default Vue.extend({
    components: { Datetime },
    props: {
        //  Forces the component to submit its form with or without changes
        alwaysSubmit: {
            type: Boolean,
            default: false
        },
        //  Determines if autofocus is turned on
        autofocus: {
            type: Boolean,
            default: false
        },
        //  Determines if the save button is shown
        button: {
            type: Boolean,
            default: true
        },
        //  The text displayed in the save button
        buttonText: {
            type: String,
            default: 'Save'
        },
        //   The color of the text displayed in the save button
        buttonTextColor: {
            type: String,
            default: '#FFFFFF',
            required: false
        },
        //  The button color
        buttonColor: {
            type: String,
            default: null,
            required: false
        },
        //  The border radius of the button
        buttonBorderRadius: {
            type: Number,
            default: 28,
            required: false
        },
        //  Forces a button to be enabled if true
        buttonForceEnable: {
            type: Boolean,
            default: false
        },
        //  The color theme of the form
        color: {
            type: String,
            default: 'primary'
        },
        //  Description of the form
        description: {
            type: String,
            default: null
        },
        //  The css class applied to form wrapper
        formClass: {
            type: [String, Object],
            default: 'px-4 pb-4'
        },
        //  The inputs to include in the form
        inputs: {
            type: Array,
            default: null,
            required: true
        },
        //  If invoice template, show invoice tags in message-text-form
        isInvoice: {
            type: Boolean,
            default: false,
            required: false
        },
        //  Determines is the loading spinner is shown
        loading: {
            type: Boolean,
            default: false
        },
        //  Determines if the app dialog is closed when the 'save' button is pressed on an unedited form
        persist: {
            type: Boolean,
            default: false
        },
        //  The object we are updating/creating
        model: {
            type: [Object],
            required: true
        }
    },
    data() {
        return {
            //  Tracks if the form has been edited
            edited: false,
            //  The temporay model we are updating/creating
            temp: null,
            //  An array of v-models for validating phones
            phones: [],
            // Maps opened/closed color pickers
            pickerDisplay: {}
        }
    },
    mounted() {
        //  Create a deep clone for editing (this allows us to revert changes if needed)
        this.temp = window._.cloneDeep(this.model)

        //  Initialize v-models for phone validation
        this.phonesInit()

        //  We use a timeout here to make sure the dom is loaded before we attempt to focus on an input (Quirk related to hosting the form in a modal or stepper)
        setTimeout(() => {
            //  Check if autofocus is set
            const focus = !this.isApp && this.autofocus

            //  If autofocus is set, focus on the input
            if (focus) this.$refs.input0[0].$refs.input.focus()
        }, 300)
    },
    computed: {
        isApp(): boolean {
            return this.$store.getters.isApp
        },
        requiredFieldsFilled(): boolean {
            if (this.inputs) {
                let valid = true
                this.inputs.forEach((input) => {
                    if (input.required && !this.getObjectValue(input)) valid = false
                })
                return valid
            }
            return true
        }
    },
    methods: {
        closePicker(_, index: number): void {
            //  If the picker is opened, close it and emit the pickerClosed event
            if (this.pickerDisplay[index]) {
                this.pickerDisplay[index] = false
                return this.$emit('pickerClosed', this.temp)
            }
        },
        //  Called when a field of type "TEXT" is modified, emits event to parent component
        emitChangeEvent(val: string, input: Input): void {
            // Emit the change
            this.$emit('change', input, val, this.temp)
        },
        emitBlurEvent(event: Event, input: Input): void {
            let val = null

            //  Cast our event target to a target
            const target = event?.target as HTMLInputElement

            // Get the value
            input.type === 'SLIDER' ? (val = event) : (val = target.value)

            // If the value is an empty string, convert it to null
            val === '' && (val = null)

            // Emit the blur
            this.$emit('blur', input, val, this.temp)
        },
        //  Get a value from temp, using a dot-notated path
        getObjectValue(input: Input): string {
            //  If the input path does NOT exist, do nothing
            if (!input.path) return

            //  Else, get the current value
            const val = objectGet(input.path, this.temp)

            //  Return the value
            return val
        },
        //  Get the value from the [function,string,bool,int] bound to the input
        getInputValue(input: Function | string): string {
            //  If the input type is 'function', we pass the current object into the function
            if (typeof input === 'function') return input(this.temp)

            //  Else, the input is a value, so return it
            return input
        },
        //  Create a v-model for each phone input, this is used for validation purposes
        phonesInit(): void {
            //  Iterate through each input
            for (let i = 0; i < this.inputs.length; i++) {
                //  Reference the input
                const input = this.inputs[i]

                //  If the input type is phone...
                if (input.type === 'PHONE') {
                    //  Get the value
                    const val = this.getObjectValue(input)

                    //  Push the filtered phone value to the v-model
                    this.phones[i] = this.$options.filters.phoneTrim(val)
                }
            }
        },
        setMedia(value: Media): void {
            //  Grab our media id
            const mediaId = value ? value.id : null

            //  Check if this is any different from the current
            const diff = mediaId !== this.temp.media_id

            //  If it isn't different, do nothing
            if (!diff) return

            //  Set our value
            this.temp.media_id = mediaId

            //  We edited
            this.edited = true
        },
        //  Set a value on temp, using a dot-notated path
        setObjectValue(value: string, input: Input): void {
            //  If the value is an 'invalid date' from the datetime plugin, do NOT write the value
            if (value === 'Invalid date' && input.type === 'DATE') return

            //  Set 'edited' to true, since a change is happening
            this.edited = true

            //  If the path and model exist, set the value
            if (input.path && this.temp) {
                objectSet(input.path, value, this.temp)
                this.emitChangeEvent(value, input)
            }
        },
        // Set a value on the date object only if it is valid
        setDateValue(value: string, input: Input): void {
            //  Set 'edited' to true, since a change is happening
            this.edited = true

            // Value can be null
            if (!value) this.setObjectValue(value, input)

            //  Format the date for the API
            const val = moment(value).utc().format('MM/DD/YYYY')

            //  Set the value
            this.setObjectValue(val, input)
        },
        //  Set the value of a phone field
        setPhoneValue(value: string, input: Input): void {
            //  Unmask the value
            let numeric = unmask(value, '(###) ###-####')

            //  Add the north american country code ONLY IF VALUE EXISTS
            numeric = numeric ? `1${numeric}` : null

            //  Set the phone value
            this.setObjectValue(numeric, input)
        },
        //  Toggles a color picker to be on or off
        togglePicker(index: number): void {
            //  If the picker is open, close the picker
            if (this.pickerDisplay[index]) {
                return this.closePicker(null, index)
            }

            //  Invert the picker value
            this.pickerDisplay[index] = true

            //  This allows vue to detect the changes
            this.pickerDisplay = { ...this.pickerDisplay }
        },
        //  Submit the form to its parent
        async submit(): Promise<void> {
            //  If the form has been edited, we submit it
            if (this.edited) {
                //  Validate the form
                const valid = await this.$validator.validate()

                //  If the form is NOT valid, do nothing
                if (!valid) return

                //  Else, if close-on-submit is set, close the app dialog
                if (this.closeOnSubmit) this.$store.dispatch('dialogClose', 'APP')

                //  Emit the changes to the parent component
                return this.$emit('submit', this.temp)
            }

            //  If the persist prop is set, validate the form
            if (this.persist) return this.$validator.validate()

            //  If the alwaysSubmit prop is set, submit the unedited form
            if (this.alwaysSubmit) this.$emit('submit', this.temp)

            //  Else, close the app dialog
            this.$store.dispatch('dialogClose', 'APP')
        }
    }
})
